import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {HelpersService} from '../../helpers.service';
import {isNil} from 'lodash-es';
import moment from 'moment';
import {FormGroup} from '@angular/forms';

/**
 * TODO replace with a validator based solution
 */
@Component({
    selector: 'app-form-date-range-filter',
    templateUrl: './form-date-range-filter.component.html',
    styleUrls: ['./form-date-range-filter.component.scss'],
    standalone: false
})
export class FormDateRangeFilterComponent implements OnInit {

  @ViewChild('startDateInput', { static: true }) public readonly startDateRef: Input;
  @ViewChild('endDateInput', { static: true }) public readonly endDateRef: Input;

  @Input()
  formGroup: FormGroup;
  @Input()
  startDateControl: string;
  @Input()
  endDateControl: string;

  private startDate: Date;
  private endDate: Date;

  @Input() startDateLabel: string;
  @Input() endDateLabel: string;
  @Input() datesNotInOrderError: string;


  validStartDate = true;
  validEndDate = true;

  minDate = new Date(1);
  maxStartDate = new Date();
  minEndDate = new Date(1);

  datesInOrder = true;

  constructor(
    private helpersService: HelpersService,
    private changeDetector: ChangeDetectorRef,
  ) {
  }


  resetDates(startDate: Date = null, endDate: Date = null) {

    this.minDate = new Date(1);
    this.maxStartDate = new Date();
    this.minEndDate = new Date();

    this.validStartDate = true;
    this.validEndDate = true;
    this.datesInOrder = true;


    this.clearHours(startDate);
    this.setControlValue(this.startDateRef, startDate);

    this.clearHours(endDate);
    this.setControlValue(this.endDateRef, endDate);

    this.setStartDate(startDate);
    this.setEndDate(endDate);
  }


  controlDatesInOrder(): boolean {
    const startDateCtrl: Date = this.getControlValue(this.startDateRef);
    const endDateCtrl: Date =  this.getControlValue(this.endDateRef);

    if (!this.isValidDate(this.startDateRef) || !this.isValidDate(this.endDateRef)) {
      return false;
    }

    if(!isNil(startDateCtrl) && !isNil(endDateCtrl)) {
      //we care about order
      this.datesInOrder =  startDateCtrl <= endDateCtrl;
    } else {
     this.datesInOrder = true;
    }
    return this.datesInOrder;
  }


  checkDatesInOrder() {
    if(this.validStartDate && this.validEndDate && !isNil(this.startDate) && !isNil(this.endDate)) {
      //we care about order
      this.datesInOrder = this.startDate < this.endDate;
    } else {
      this.datesInOrder = true;
    }
  }


  setStartDate($event: any) {
    this.validStartDate = this.isValidDate(this.startDateRef);
    if (this.validStartDate && this.controlDatesInOrder()) {

      const dateVal = $event instanceof Date ? $event : $event.value;
      this.startDate = dateVal;
      this.minEndDate = this.startDate;

      this.setFormControlValue(this.startDateControl, this.startDate);

      const endDateControl = this.getControlValue(this.endDateRef);
      if(endDateControl?.getTime() !== this.endDate?.getTime()) {
        this.setEndDate(endDateControl);
      }
    }
  }


  setEndDate($event: any) {
    this.validEndDate = this.isValidDate(this.endDateRef)
    if (this.validEndDate && this.controlDatesInOrder()) {

      const dateVal = $event instanceof Date ? $event : $event.value;

      this.endDate = dateVal;
      this.maxStartDate = this.endDate;
      this.setFormControlValue(this.endDateControl, this.endDate);

      const startDateControl = this.getControlValue(this.startDateRef);

      if(startDateControl?.getTime() !== this.startDate?.getTime()) {
        this.setStartDate(startDateControl);
      }
    }
  }

  private setFormControlValue(formControlName, value: Date) {
    this.formGroup.controls[formControlName].setValue(value);
    this.formGroup.controls[formControlName].setErrors(null);
    this.formGroup.controls[formControlName].updateValueAndValidity();
    this.changeDetector.detectChanges();
  }

  private isValidDate(dateInput: Input) {
    const inputValue = dateInput['nativeElement'].value;
    return this.helpersService.isValidDate(inputValue);
  }

  private getControlValue(dateInput: Input): Date {
    const controlString = dateInput['nativeElement'].value;
    return !isNil(controlString) && controlString !== '' ? moment(controlString).toDate() : null;
  }


  private setControlValue(dateRef: Input, date: Date) {
    if(!isNil(date)) {
      dateRef['nativeElement'].value = moment(date).format('MM/DD/YYYY');
    } else {
      dateRef['nativeElement'].value = null;
    }
  }

  private clearHours(date: Date) {
    date?.setHours(0,0,0,0);
  }

  ngOnInit(): void {
    const formStartDate = this.formGroup.controls[this.startDateControl].value;
    this.startDate = !isNil(formStartDate) ? moment(formStartDate).toDate() : null;
    const formEndDate = this.formGroup.controls[this.endDateControl].value;
    this.endDate = !isNil(formEndDate) ? moment(formEndDate).toDate() : null;
  }

}
